module.exports = __webpack_public_path__ + "img/tipocontacto07.3331ed7.svg";